import React from 'react';

//import {toLocalTime} from "../utils/ToLocalTime"
//import {setInStorage,removeFromStorage} from '../utils/storage.js';
import 'whatwg-fetch';
import '../App.css';
import User from './User.js'
import Anon from './Anon.js'
import Wizard from './Wizard.js'


function Content(props){
  /*props = {
      signedIn
      userToken,
      userName,
      userID,
      email,
      role,
    group}*/

  const {role} = props.userInfo;
  function handleChange(newUserInfo){
    props.onChange(newUserInfo)
  }

  return(
    <div className="joinOuterContainer">
        <div className= "joinInnerContainer">
            {role==='anon' ? <Anon/>
            :role===0 ? <User userInfo={props.userInfo} onChange={handleChange}/>
            :role===1 ? <Wizard userInfo={props.userInfo} onChange={handleChange}/>
            : <h1>Unknown user role. Please contact your admin.</h1>
            }
        </div>
        <div className="footerSpace"></div>
    </div>
  )
}

export default Content
